import React, { useState } from 'react';
//import ReactDOM, { render } from 'react-dom';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { registerLicense } from '@syncfusion/ej2-base';
import Requests from './components/Requests/Requests';
import { User } from 'oidc-client-ts';
import { PublicClientApplication, EventType, InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest, msalConfig } from "./authConfig";


// Registering Syncfusion license key
registerLicense('Ngo9BigBOggjHTQxAR8/V1JEaF5cXmRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWX1fc3RSQ2lfUEZwV0FWYE0=');
const myMSALObj = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(<App instance={myMSALObj} />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
/*reportWebVitals();*/
